export default __webpack_public_path__ + "static/media/leftBackground3.6bf54f32.png";